export default function () {

    return {
        namespaced: true,

        state: {},

        getters: {},

        mutations: {},

        actions: {},
    }
}
